import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SandboxComponent } from './sandbox/sandbox.component';
import { StagingComponent } from './staging/staging.component';
import { ProductionComponent } from './production/production.component';
import { ConfigComponent } from './config/config.component';
import { PricingComponent } from './pricing/pricing.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'sandbox', component: SandboxComponent, canActivate: [AuthGuard] },
  { path: 'staging', component: StagingComponent, canActivate: [AuthGuard] },
  { path: 'production', component: ProductionComponent, canActivate: [AuthGuard] },
  { path: 'config', component: ConfigComponent, canActivate: [AuthGuard] },
  { path: 'pricing', component: PricingComponent, canActivate: [AuthGuard] },
  { path: 'v2', redirectTo: '/pricing', pathMatch: 'full' },
  { path: '', redirectTo: '/sandbox', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
